<template>
<div class="chapter">
<div class="inner_page">
<h1 class="fm-title" id="fm-5"><a id="page_xxiv"><em>Topical List of Entries</em></a></h1><a id="page_xxiv">
<p class="fm-entries"><strong>Primary Languages of Jews in the</strong></p>
<p class="fm-entries"><strong>Second Temple Period</strong></p>
<p class="fm-entries">Aramaic</p>
<p class="fm-entries">Greek</p>
<p class="fm-entries">Hebrew</p>
<p class="fm-entries1"><strong>Secondary Languages in Which</strong></p>
<p class="fm-entries"><strong>Early Jewish Literature Is Preserved</strong></p>
<p class="fm-entries">Armenian</p>
<p class="fm-entries">Ethiopic</p>
<p class="fm-entries">Latin</p>
<p class="fm-entries">Slavonic</p>
<p class="fm-entries">Syriac</p>
<p class="fm-entries1"><strong>Literary Genres</strong></p>
<p class="fm-entries">Adversus Judaeos Literature</p>
<p class="fm-entries">Allegory</p>
<p class="fm-entries">Apocalypse</p>
<p class="fm-entries">Apologetic Literature</p>
<p class="fm-entries">Calendars</p>
<p class="fm-entries">Chronography</p>
<p class="fm-entries">Contracts from the Judean Desert</p>
<p class="fm-entries">Court Tales</p>
<p class="fm-entries">Dream and Vision Reports</p>
<p class="fm-entries">Gematria</p>
<p class="fm-entries">Genealogies</p>
<p class="fm-entries">Historiography</p>
<p class="fm-entries">Homily</p>
<p class="fm-entries">Hymns, Prayers, and Psalms</p>
<p class="fm-entries">Legal Texts</p>
<p class="fm-entries">Letters</p>
<p class="fm-entries">Novels</p>
<p class="fm-entries">Testaments</p>
<p class="fm-entries">Wisdom Literature</p>
<p class="fm-entries1"><strong>Biblical Texts, Versions, and Canon</strong></p>
<p class="fm-entries">Canon, Canonization</p>
<p class="fm-entries">Latin Versions of the Hebrew Bible</p>
<p class="fm-entries">Peshi<span class="f1">ṭ</span>ta</p>
<p class="fm-entries">Samaritan Pentateuch</p>
<p class="fm-entries">Septuagint</p>
<p class="fm-entries">Text Types, Hebrew</p>
<p class="fm-entries1"><strong>Hebrew Bible</strong></p>
<p class="fm-entries">Chronicles, Books of 1-2</p>
<p class="fm-entries">Daniel, Book of</p>
<p class="fm-entries">Deuteronomistic History</p>
<p class="fm-entries">Esther, Book of</p>
<p class="fm-entries">Ezekiel, Book of</p>
<p class="fm-entries">Ezra, Book of</p>
<p class="fm-entries">Isaiah, Book of</p>
<p class="fm-entries">Jeremiah and Lamentations</p>
<p class="fm-entries">Job, Book of</p>
<p class="fm-entries">Minor Prophets</p>
<p class="fm-entries">Nehemiah, Book of</p>
<p class="fm-entries">Pentateuch</p>
<p class="fm-entries">Proverbs, Book of</p>
<p class="fm-entries">Psalms, Book of</p>
<p class="fm-entries">Qoheleth</p>
<p class="fm-entries">Ruth, Book of</p>
<p class="fm-entries">Song of Songs</p>
<p class="fm-entries1"><strong>Apocrypha</strong></p>
<p class="fm-entries">Apocrypha, Old Testament</p>
<p class="fm-entries">Baruch, First Book of</p>
<p class="fm-entries">Ben Sira, Book of</p>
<p class="fm-entries">Daniel, Additions to</p>
<p class="fm-entries">Esdras, First Book of</p>
<p class="fm-entries">Esther, Greek Version of</p>
<p class="fm-entries">Ezra, Fourth Book of</p>
<p class="fm-entries">Jeremiah, Letter of</p>
<p class="fm-entries">Maccabees, First Book of</p>
<p class="fm-entries">Maccabees, Second Book of</p>
<p class="fm-entries">Maccabees, Third Book of</p>
<p class="fm-entries">Maccabees, Fourth Book of</p>
<p class="fm-entries">Manasseh, Prayer of</p>
<p class="fm-entries">Psalm 151</p>
<p class="fm-entries">Solomon, Wisdom of</p>
<p class="fm-entries">Tobit, Book of</p>
<p class="fm-entries1"><strong>Pseudepigrapha and Hellenistic Jewish Texts</strong></p>
<p class="fm-entries">Abraham, Apocalypse of</p>
<p class="fm-entries">Abraham, Testament of</p>
<p class="fm-entries">Adam and Eve, Life of</p>
<p class="fm-entries">Aristeas, Letter of</p>
<p class="fm-entries">Aristobulus</p>
</a><p class="fm-entries"><a id="page_xxiv"></a><a id="page_xxv"> Artapanus</a></p><a id="page_xxv">
<p class="fm-entries">Baruch, Second Book of</p>
<p class="fm-entries">Baruch, Third Book of</p>
<p class="fm-entries">Baruch, Fourth Book of</p>
<p class="fm-entries">Biblical Antiquities (Pseudo-Philo)</p>
<p class="fm-entries">Cleodemus Malchus</p>
<p class="fm-entries">Demetrius the Chronographer</p>
<p class="fm-entries">Dreams, Book of (1 Enoch 83–90)</p>
<p class="fm-entries">Enoch, Astronomical Book of (1 Enoch 72–82)</p>
<p class="fm-entries">Enoch, Epistle of (1 Enoch 91–108)</p>
<p class="fm-entries">Enoch, Ethiopic Apocalypse of (1 Enoch)</p>
<p class="fm-entries">Enoch, Similitudes of (1 Enoch 37–71)</p>
<p class="fm-entries">Enoch, Slavonic Apocalypse of (2 Enoch)</p>
<p class="fm-entries">Eupolemus</p>
<p class="fm-entries">Eupolemus, Pseudo-</p>
<p class="fm-entries">Ezekiel the Tragedian</p>
<p class="fm-entries">Gabriel, Vision of</p>
<p class="fm-entries">Hecataeus of Abdera</p>
<p class="fm-entries">Hecataeus, Pseudo-</p>
<p class="fm-entries">Isaiah, Ascension of</p>
<p class="fm-entries">Job, Testament of</p>
<p class="fm-entries">Joseph and Aseneth</p>
<p class="fm-entries">Joseph, Prayer of</p>
<p class="fm-entries">Jubilees, Book of</p>
<p class="fm-entries">Lives of the Prophets</p>
<p class="fm-entries">Menander, Sentences of the Syriac</p>
<p class="fm-entries">Moses, Assumption of</p>
<p class="fm-entries">Orpheus, Pseudo-</p>
<p class="fm-entries">Patriarchs, Testaments of the Twelve</p>
<p class="fm-entries">Philo the Epic Poet</p>
<p class="fm-entries">Phocylides, Pseudo-</p>
<p class="fm-entries">Pseudepigrapha, Old Testament</p>
<p class="fm-entries">Sibylline Oracles (Jewish)</p>
<p class="fm-entries">Solomon, Psalms of</p>
<p class="fm-entries">Solomon, Testament of</p>
<p class="fm-entries">Thallus</p>
<p class="fm-entries">Theodotus</p>
<p class="fm-entries">Watchers, Book of the (1 Enoch 1–36)</p>
<p class="fm-entries">Zephaniah, Apocalypse of</p>
<p class="fm-entries1"><strong>Dead Sea Scrolls</strong></p>
<p class="fm-entries">Dead Sea Scrolls</p>
<p class="fm-entries">Liturgical Works from Qumran</p>
<p class="fm-entries">Paleo-Hebrew Scrolls</p>
<p class="fm-entries">Pesharim</p>
<p class="fm-entries">Wisdom Literature at Qumran</p>
<p class="fm-entries"><em>Documents arranged here by cave number are arranged by document title in the A–Z entries</em></p>
<p class="fm-entriesa">1QapGen (Genesis Apocryphon)</p>
<p class="fm-entriesa">1QH and Related Texts (Hodayot)</p>
<p class="fm-entriesa">1QIsa<sup>a, b</sup> (Isaiah Scrolls)</p>
<p class="fm-entriesa">1QM (War Scroll)</p>
<p class="fm-entriesa">1QS (Rule of the Community)</p>
<p class="fm-entriesa">1Q21 etc. (Aramaic Levi Document)</p>
<p class="fm-entriesa">1Q22, 2Q21 etc. (Moses Texts from Qumran)</p>
<p class="fm-entriesa">1Q23-24 (Giants, Book of)</p>
<p class="fm-entriesa">1Q26 etc. (Instruction)</p>
<p class="fm-entriesa">1Q28a (Rule of the Congregation)</p>
<p class="fm-entriesa">1Q28b (Rule of Blessings)</p>
<p class="fm-entriesa">1Q32 etc. (New Jerusalem)</p>
<p class="fm-entriesa">2Q22 (David Apocryphon)</p>
<p class="fm-entriesa">3Q15 (Copper Scroll)</p>
<p class="fm-entriesa">4Q156 (Leviticus Targum)</p>
<p class="fm-entriesa">4Q157, 11Q10 (Job Targum)</p>
<p class="fm-entriesa">4Q158, 364-367 (Reworked Pentateuch)</p>
<p class="fm-entriesa">4Q159 etc. (Ordinances)</p>
<p class="fm-entriesa">4Q174 (Florilegium)</p>
<p class="fm-entriesa">4Q175 (Testimonia)</p>
<p class="fm-entriesa">4Q176 (Tan<span class="f1">ḥ</span>umim)</p>
<p class="fm-entriesa">4Q177, 182 (Catenae)</p>
<p class="fm-entriesa">4Q180 (Pesher on the Periods)</p>
<p class="fm-entriesa">4Q181 (Wicked and Holy)</p>
<p class="fm-entriesa">4Q186, 534, 561 (Horoscopes)</p>
<p class="fm-entriesa">4Q215 (Naphtali, Testament of)</p>
<p class="fm-entriesa">4Q242-245, 246 (Daniel, Pseudo-Texts)</p>
<p class="fm-entriesa">4Q252-254 (Genesis Commentaries)</p>
<p class="fm-entriesa">4Q265-273, etc. + CD (Damascus Document)</p>
<p class="fm-entriesa">4Q274 etc. (Tohorot)</p>
<p class="fm-entriesa">4Q285, 11Q14 (War, Book of)</p>
<p class="fm-entriesa">4Q286-290 (Berakhot)</p>
<p class="fm-entriesa">4Q319 (<span class="f1">ʾ</span>Otot)</p>
<p class="fm-entriesa">4Q320 etc. (Mishmarot)</p>
<p class="fm-entriesa">4Q371-373 (Joseph, Apocryphon of)</p>
<p class="fm-entriesa">4Q378-379 (Joshua, Apocryphon of)</p>
<p class="fm-entriesa">4Q380-381 (Psalms, Apocryphal)</p>
<p class="fm-entriesa">4Q385-390 (Prophets, Pseudo-)</p>
<p class="fm-entriesa">4Q394-399 (Miq<span class="f1">ṣ</span>at Ma<span class="f1">ʿ</span>aśê ha-Torah)</p>
<p class="fm-entriesa">4Q400-407 etc. (Songs of the Sabbath Sacrifice)</p>
<p class="fm-entriesa">4Q422 (Genesis and Exodus, Commentary on)</p>
<p class="fm-entriesa">4Q434 etc. (Barki Nafshi)</p>
<p class="fm-entriesa">4Q448 (Jonathan the King Text)</p>
<p class="fm-entriesa">4Q491 etc. (Self-Glorification Hymn)</p>
<p class="fm-entriesa">4Q504-506 (Words of the Luminaries)</p>
<p class="fm-entriesa">4Q521 (Messianic Apocalypse)</p>
<p class="fm-entriesa">4Q525 (Beatitudes)</p>
<p class="fm-entriesa">4Q534-536 (Elect of God)</p>
<p class="fm-entriesa">4Q542 (Admonitions [Testament] of Qahat)</p>
<p class="fm-entriesa">4Q543-548 (Amram, Visions of)</p>
<p class="fm-entriesa">4Q550 (Tales of the Persian Court)</p>
<p class="fm-entriesa">7Q1 etc. (Papyri from Qumran Cave 7)</p>
<p class="fm-entriesa">11Q11 etc. (Psalms Scrolls)</p>
<p class="fm-entriesa">11Q13 (Melchizedek Scroll)</p>
<p class="fm-entriesa">11Q19 (Temple Scroll)</p>
<p class="fm-entries1"><strong>Philo of Alexandria</strong></p>
<p class="fm-entries">Philo</p>
<p class="fm-entries">Philo, Allegorical Commentary</p>
<p class="fm-entries">Philo, Apologetic Treatises</p>
<p class="fm-entries">Philo, Exposition of the Law</p>
<p class="fm-entries">Philo, Philosophical Works</p>
<p class="fm-entries">Philo, Questions and Answers on Genesis and Exodus</p>
<p class="fm-entries1"><strong>Josephus</strong></p>
<p class="fm-entries">Josephus</p>
<p class="fm-entries">Josephus, Against Apion</p>
<p class="fm-entries">Josephus, Jewish Antiquities</p>
<p class="fm-entries">Josephus, Jewish War</p>
<p class="fm-entries1"><strong>Greek and Latin Authors on Jews and Judaism</strong></p>
<p class="fm-entries">Greek Authors on Jews and Judaism</p>
<p class="fm-entries">Latin Authors on Jews and Judaism</p>
<p class="fm-entries">Alexander Polyhistor</p>
</a><p class="fm-entries"><a id="page_xxv"></a><a id="page_xxvi">Apollonius Molon</a></p><a id="page_xxvi">
<p class="fm-entries">Berossus</p>
<p class="fm-entries">Hecataeus of Abdera</p>
<p class="fm-entries">Manetho</p>
<p class="fm-entries1"><strong>New Testament</strong></p>
<p class="fm-entries">Hebrews, Epistle to the</p>
<p class="fm-entries">James, Epistle of</p>
<p class="fm-entries">John, Gospel of</p>
<p class="fm-entries">Jude, Epistle of</p>
<p class="fm-entries">Luke-Acts</p>
<p class="fm-entries">Mark, Gospel of</p>
<p class="fm-entries">Matthew, Gospel of</p>
<p class="fm-entries">Paul</p>
<p class="fm-entries">Peter, Epistles of</p>
<p class="fm-entries">Revelation, Book of</p>
<p class="fm-entries1"><strong>Rabbinic Literature</strong></p>
<p class="fm-entries">Babylonian Talmud</p>
<p class="fm-entries">Hekhalot Literature</p>
<p class="fm-entries">Midrash, Midrashim</p>
<p class="fm-entries">Mishnah</p>
<p class="fm-entries">Palestinian Talmud</p>
<p class="fm-entries">Targum, Targumim</p>
<p class="fm-entries">Tosefta</p>
<p class="fm-entries1"><strong>NONLITERATURE ARTICLES</strong></p>
<p class="fm-entries1"><strong>Groups and Dynasties</strong></p>
<p class="fm-entries">Babylonians</p>
<p class="fm-entries">Boethusians</p>
<p class="fm-entries">Diadochi</p>
<p class="fm-entries">Elders</p>
<p class="fm-entries">Essenes</p>
<p class="fm-entries">God-fearers</p>
<p class="fm-entries">Hasideans</p>
<p class="fm-entries">Hasmoneans</p>
<p class="fm-entries">Herodian Dynasty</p>
<p class="fm-entries">High Priests</p>
<p class="fm-entries">Ioudaios/oi</p>
<p class="fm-entries">Jesus Movement</p>
<p class="fm-entries">Jewish Christianity</p>
<p class="fm-entries">Levites</p>
<p class="fm-entries">Oniads</p>
<p class="fm-entries">Parthians</p>
<p class="fm-entries">People of the Land</p>
<p class="fm-entries">Pharisees</p>
<p class="fm-entries">Priests</p>
<p class="fm-entries">Prophecy</p>
<p class="fm-entries">Ptolemies</p>
<p class="fm-entries">Rabbis</p>
<p class="fm-entries">Resistance Movements</p>
<p class="fm-entries">Roman Emperors</p>
<p class="fm-entries">Roman Generals</p>
<p class="fm-entries">Roman Governors</p>
<p class="fm-entries">Sadducees</p>
<p class="fm-entries">Scribes and Scribalism</p>
<p class="fm-entries">Seleucids</p>
<p class="fm-entries">Therapeutae</p>
<p class="fm-entries">Tobiads</p>
<p class="fm-entries">Zadokites</p>
<p class="fm-entries1"><strong>Groups in Society</strong></p>
<p class="fm-entries">Family</p>
<p class="fm-entries">Military, Jews in</p>
<p class="fm-entries">Slaves, Slavery</p>
<p class="fm-entries">Women</p>
<p class="fm-entries1"><strong>Social, Political, Economic, and Cultural Life</strong></p>
<p class="fm-entries">Agriculture in Palestine</p>
<p class="fm-entries">Architecture</p>
<p class="fm-entries">Archives and Libraries</p>
<p class="fm-entries">Art</p>
<p class="fm-entries">Associations</p>
<p class="fm-entries">Athletics</p>
<p class="fm-entries">Baths</p>
<p class="fm-entries">Burial Practices</p>
<p class="fm-entries">Clothing and Dress</p>
<p class="fm-entries">Diet in Palestine</p>
<p class="fm-entries">Economics in Palestine</p>
<p class="fm-entries">Education</p>
<p class="fm-entries">Gymnasium</p>
<p class="fm-entries">Hellenism, Hellenization</p>
<p class="fm-entries">Imperial Cult, Jews and</p>
<p class="fm-entries">Kingship</p>
<p class="fm-entries">Medicine and Hygiene</p>
<p class="fm-entries">Music</p>
<p class="fm-entries">Names</p>
<p class="fm-entries">Parting of the Ways</p>
<p class="fm-entries">Peace</p>
<p class="fm-entries">Persian Period</p>
<p class="fm-entries">Rights of Jews in the Roman World</p>
<p class="fm-entries">Romanization</p>
<p class="fm-entries">Temple Tax</p>
<p class="fm-entries">Theaters</p>
<p class="fm-entries">Tribute and Taxes</p>
<p class="fm-entries">Violence</p>
<p class="fm-entries1"><strong>Biblical Figures in Early Jewish Interpretation</strong></p>
<p class="fm-entries">Aaron</p>
<p class="fm-entries">Abraham</p>
<p class="fm-entries">Adam and Eve</p>
<p class="fm-entries">Cain and Abel</p>
<p class="fm-entries">David</p>
<p class="fm-entries">Elijah</p>
<p class="fm-entries">Elisha</p>
<p class="fm-entries">Enoch</p>
<p class="fm-entries">Enosh</p>
<p class="fm-entries">Isaac</p>
<p class="fm-entries">Jacob</p>
<p class="fm-entries">Joseph</p>
<p class="fm-entries">Judah</p>
<p class="fm-entries">Levi</p>
<p class="fm-entries">Melchizedek</p>
<p class="fm-entries">Moses</p>
<p class="fm-entries">Noah</p>
<p class="fm-entries">Seth</p>
<p class="fm-entries">Solomon</p>
<p class="fm-entries1"><strong>Historical Figures</strong></p>
<p class="fm-entries">Akiba (Aqiva)</p>
</a><p class="fm-entries"><a id="page_xxvi"></a><a id="page_xxvii"> Alexander the Great</a></p><a id="page_xxvii">
<p class="fm-entries">Antiochus IV Epiphanes</p>
<p class="fm-entries">Cyrus the Great</p>
<p class="fm-entries">Herod the Great</p>
<p class="fm-entries">Hillel</p>
<p class="fm-entries">Ishmael ben Elisha</p>
<p class="fm-entries">Jesus of Nazareth</p>
<p class="fm-entries">John the Baptist</p>
<p class="fm-entries">Joshua (Jeshua), the High Priest</p>
<p class="fm-entries">Judas Maccabaeus</p>
<p class="fm-entries">Julius Caesar, Gaius</p>
<p class="fm-entries">Justus of Tiberius</p>
<p class="fm-entries">Nebuchadnezzar</p>
<p class="fm-entries">Nicolaus of Damascus</p>
<p class="fm-entries">Sanballat</p>
<p class="fm-entries">Shammai</p>
<p class="fm-entries">Sheshbazzar</p>
<p class="fm-entries">Tiberius Julius Alexander</p>
<p class="fm-entries">Tobiah</p>
<p class="fm-entries">Zerubbabel</p>
<p class="fm-entries">Yo<span class="f1">ḥ</span>anan ben Zakkai</p>
<p class="fm-entries1"><strong>Mythological and Primordial Figures,</strong></p>
<p class="fm-entries"><strong>Places, and Events</strong></p>
<p class="fm-entries">Angels</p>
<p class="fm-entries">Aqedah</p>
<p class="fm-entries">Babel, Tower of</p>
<p class="fm-entries">Behemoth</p>
<p class="fm-entries">Belial</p>
<p class="fm-entries">Creation</p>
<p class="fm-entries">Demons and Exorcism</p>
<p class="fm-entries">Exodus, the</p>
<p class="fm-entries">Fallen Angels</p>
<p class="fm-entries">Flood</p>
<p class="fm-entries">Garden of Eden — Paradise</p>
<p class="fm-entries">Geography, Mythic</p>
<p class="fm-entries">Giants</p>
<p class="fm-entries">Heaven</p>
<p class="fm-entries">Jerusalem, New</p>
<p class="fm-entries">Leviathan</p>
<p class="fm-entries">Logos</p>
<p class="fm-entries">Metatron</p>
<p class="fm-entries">Michael, the Archangel</p>
<p class="fm-entries">Phoenix</p>
<p class="fm-entries">Satan and Related Figures</p>
<p class="fm-entries">Serpent</p>
<p class="fm-entries">Sons of God</p>
<p class="fm-entries">Stars</p>
<p class="fm-entries">Sun and Moon</p>
<p class="fm-entries">Wisdom (Personified)</p>
<p class="fm-entries1"><strong>Religious Beliefs and Influences</strong></p>
<p class="fm-entries">Animal Worship</p>
<p class="fm-entries">Antichrist</p>
<p class="fm-entries">Apocalypticism</p>
<p class="fm-entries">Apostasy</p>
<p class="fm-entries">Ascent to Heaven</p>
<p class="fm-entries">Atonement</p>
<p class="fm-entries">Babylonian Culture</p>
<p class="fm-entries">Birth, Miraculous</p>
<p class="fm-entries">Blasphemy</p>
<p class="fm-entries">Cosmology</p>
<p class="fm-entries">Covenant</p>
<p class="fm-entries">Covenantal Nomism</p>
<p class="fm-entries">Death and Afterlife</p>
<p class="fm-entries">Decalogue</p>
<p class="fm-entries">Determinism</p>
<p class="fm-entries">Dualism</p>
<p class="fm-entries">Election</p>
<p class="fm-entries">Eschatology</p>
<p class="fm-entries">Ethics</p>
<p class="fm-entries">Evil</p>
<p class="fm-entries">Exile</p>
<p class="fm-entries">Faith, Faithfulness</p>
<p class="fm-entries">Gentile Attitudes toward Jews and Judaism</p>
<p class="fm-entries">Gentiles, Jewish Attitudes toward</p>
<p class="fm-entries">Gnosticism</p>
<p class="fm-entries">Grace</p>
<p class="fm-entries">Greek Philosophy</p>
<p class="fm-entries">Greek Religions</p>
<p class="fm-entries">Holiness</p>
<p class="fm-entries">Idols and Images</p>
<p class="fm-entries">Judgment</p>
<p class="fm-entries">Kingdom of God</p>
<p class="fm-entries">Land, Concept of</p>
<p class="fm-entries">Martyrdom</p>
<p class="fm-entries">Mediator Figures</p>
<p class="fm-entries">Messianism</p>
<p class="fm-entries">Miracles and Miracle Workers</p>
<p class="fm-entries">Monotheism</p>
<p class="fm-entries">Mystery</p>
<p class="fm-entries">Mystery Religion, Judaism as</p>
<p class="fm-entries">Mysticism</p>
<p class="fm-entries">Pagan Religions</p>
<p class="fm-entries">Persecuted Righteous Person</p>
<p class="fm-entries">Persian Religion</p>
<p class="fm-entries">Repentance</p>
<p class="fm-entries">Restoration</p>
<p class="fm-entries">Resurrection</p>
<p class="fm-entries">Righteousness/Justice</p>
<p class="fm-entries">Samaritanism</p>
<p class="fm-entries">Sickness and Disease</p>
<p class="fm-entries">Sin</p>
<p class="fm-entries">Son of God</p>
<p class="fm-entries">Son of Man</p>
<p class="fm-entries">Spirit, Holy</p>
<p class="fm-entries">Suffering Servant</p>
<p class="fm-entries">Theodicy</p>
<p class="fm-entries">Torah and Tradition</p>
<p class="fm-entries">Universalism</p>
<p class="fm-entries">Wealth and Poverty</p>
<p class="fm-entries">Wilderness</p>
<p class="fm-entries1"><strong>Practices</strong></p>
<p class="fm-entries">Almsgiving</p>
<p class="fm-entries">Asceticism</p>
<p class="fm-entries">Assimilation, Acculturation, Accommodation</p>
<p class="fm-entries">Astronomy and Astrology</p>
<p class="fm-entries">Burial Practices</p>
<p class="fm-entries">Celibacy</p>
<p class="fm-entries">Circumcision</p>
<p class="fm-entries">Conversion and Proselytism</p>
</a><p class="fm-entries"><a id="page_xxvii"></a><a id="page_xxviii">Crucifixion</a></p><a id="page_xxviii">
<p class="fm-entries">Divination and Magic</p>
<p class="fm-entries">Family Religion</p>
<p class="fm-entries">Fasting</p>
<p class="fm-entries">Healing</p>
<p class="fm-entries">Intermarriage</p>
<p class="fm-entries">Judaizing</p>
<p class="fm-entries">Literacy and Reading</p>
<p class="fm-entries">Marriage and Divorce</p>
<p class="fm-entries">Meals</p>
<p class="fm-entries">Multilingualism</p>
<p class="fm-entries">Oaths and Vows</p>
<p class="fm-entries">Penitential Prayer</p>
<p class="fm-entries">Popular Religion</p>
<p class="fm-entries">Pseudepigraphy</p>
<p class="fm-entries">Pilgrimage</p>
<p class="fm-entries">Purity and Impurity</p>
<p class="fm-entries">Sabbath</p>
<p class="fm-entries">Sacrifices and Offerings</p>
<p class="fm-entries">Scripts and Scribal Practices</p>
<p class="fm-entries">Sectarianism</p>
<p class="fm-entries">Sexuality</p>
<p class="fm-entries">Tithing</p>
<p class="fm-entries">Washing, Ritual</p>
<p class="fm-entries">Worship</p>
<p class="fm-entries">Writing</p>
<p class="fm-entries1"><strong>Religious Institutions</strong></p>
<p class="fm-entries">Festivals and Holy Days</p>
<p class="fm-entries">Sanhedrin</p>
<p class="fm-entries">Synagogues</p>
<p class="fm-entries">Temple, Jerusalem</p>
<p class="fm-entries1"><strong>Jewish Revolts</strong></p>
<p class="fm-entries">Bar Kokhba Revolt</p>
<p class="fm-entries">Diaspora Uprisings (116-117 <span class="smallcaps">C.E.</span>)</p>
<p class="fm-entries">Maccabean Revolt</p>
<p class="fm-entries">Revolt, First Jewish</p>
<p class="fm-entries1"><strong>Cities, Countries, and Regions:</strong></p>
<p class="fm-entries"><strong>Jews and Judaism in</strong></p>
<p class="fm-entries">Adiabene</p>
<p class="fm-entries">Alexandria</p>
<p class="fm-entries">Antioch (Pisidia)</p>
<p class="fm-entries">Antioch (Syria)</p>
<p class="fm-entries">Aphrodisias</p>
<p class="fm-entries">Arabian Peninsula</p>
<p class="fm-entries">Asia Minor</p>
<p class="fm-entries">Caesarea Maritima</p>
<p class="fm-entries">Cyprus</p>
<p class="fm-entries">Cyrenaica</p>
<p class="fm-entries">Damascus</p>
<p class="fm-entries">Decapolis</p>
<p class="fm-entries">Egypt</p>
<p class="fm-entries">Elephantine, Elephantine Papyri</p>
<p class="fm-entries">Galilee</p>
<p class="fm-entries">Gamla</p>
<p class="fm-entries">Greece and the Aegean</p>
<p class="fm-entries">Heliopolis</p>
<p class="fm-entries">Idumea</p>
<p class="fm-entries">Iturea</p>
<p class="fm-entries">Jericho</p>
<p class="fm-entries">Jerusalem</p>
<p class="fm-entries">Jotapata</p>
<p class="fm-entries">Judea</p>
<p class="fm-entries">Mesopotamia, Media, and Babylonia</p>
<p class="fm-entries">Nabatea</p>
<p class="fm-entries">Ostia</p>
<p class="fm-entries">Paneion</p>
<p class="fm-entries">Rome</p>
<p class="fm-entries">Samaria</p>
<p class="fm-entries">Samaria-Sebaste</p>
<p class="fm-entries">Sardis</p>
<p class="fm-entries">Sepphoris</p>
<p class="fm-entries">Syria</p>
<p class="fm-entries">Tiberias</p>
<p class="fm-entries">Transjordan</p>
<p class="fm-entries">Yavneh (Jamnia)</p>
<p class="fm-entries1"><strong>Archaeology:</strong></p>
<p class="fm-entries"><strong>Specific Sites in or near the Land of Israel</strong></p>
<p class="fm-entries"><span class="f1">ʿ</span>Araq el-Emir</p>
<p class="fm-entries">Daliyeh, Wadi ed-</p>
<p class="fm-entries"><span class="f1">ʿ</span>Ein Feshka</p>
<p class="fm-entries"><span class="f1">ʿ</span>Ein Gedi</p>
<p class="fm-entries">Gerizim, Mount</p>
<p class="fm-entries">Hermon, Mount</p>
<p class="fm-entries"><span class="f1">Ḥ</span>ever, Na<span class="f1">ḥ</span>al</p>
<p class="fm-entries">Masada</p>
<p class="fm-entries">Murabba<span class="f1">ʿ</span>at, Wadi</p>
<p class="fm-entries">Qumran</p>
<p class="fm-entries1"><strong>Archaeology:</strong></p>
<p class="fm-entries"><strong>Structures, Artifacts, Written Remains</strong></p>
<p class="fm-entries">Amulets</p>
<p class="fm-entries">Aqueducts</p>
<p class="fm-entries">Arch of Titus</p>
<p class="fm-entries">Babatha Archive</p>
<p class="fm-entries">Bar Kokhba Caves</p>
<p class="fm-entries">Bar Kokhba Letters</p>
<p class="fm-entries">Catacombs</p>
<p class="fm-entries">Cisterns and Reservoirs</p>
<p class="fm-entries">Coins</p>
<p class="fm-entries">Domestic Dwellings in Roman Palestine</p>
<p class="fm-entries">Entertainment Structures</p>
<p class="fm-entries">Fortresses and Palaces</p>
<p class="fm-entries">Herakleopolis Papyri</p>
<p class="fm-entries">Inscriptions</p>
<p class="fm-entries">Jewelry</p>
<p class="fm-entries">Magic Bowls and Incantations</p>
<p class="fm-entries">Miqva<span class="f1">ʾ</span>ot</p>
<p class="fm-entries">Mosaics</p>
<p class="fm-entries">Ossuaries</p>
<p class="fm-entries">Papyri</p>
<p class="fm-entries">Phylacteries and Mezuzot</p>
<p class="fm-entries">Pottery</p>
<p class="fm-entries">Seals and Seal Impressions</p>
<p class="fm-entries">Stone Vessels</p>
<p class="fm-entries1"><strong>Modern Interpreters of Early Judaism</strong></p>
<p class="fm-entries">Bickerman Elias</p>
<p class="fm-entries">Bousset, Wilhelm</p>
</a><p class="fm-entries"><a id="page_xxviii"></a><a id="page_xxix">Charles, Robert Henry</a></p><a id="page_xxix">
<p class="fm-entries">Goodenough, Erwin Ramsdell</p>
<p class="fm-entries">Hengel, Martin</p>
<p class="fm-entries">Moore, George Foote</p>
<p class="fm-entries">Neusner, Jacob</p>
<p class="fm-entries">Sanders, Ed Parish</p>
<p class="fm-entries">Schürer, Emil</p>
<p class="fm-entries">Smith, Morton</p>
<p class="fm-entries">Tcherikover, Victor (Avigdor)</p>
<p class="fm-entries">Wolfson, Harry Austryn</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 010_Topical_List.vue?97b0ff9c